import React from "react";
import { InfoWindowF } from "@react-google-maps/api";

const SearchInfoWindow = ({ centre, onClose }) => {
  if (
    !centre ||
    isNaN(parseFloat(centre.latitude)) ||
    isNaN(parseFloat(centre.longitude))
  ) {
    return null;
  }

  const lat = parseFloat(centre.latitude);
  const lng = parseFloat(centre.longitude);

  console.log("[InfoWindow] Rendering for:", centre.id, centre.sitename);

  return (
    <InfoWindowF
      key={`search-${centre.id}`}
      position={{ lat, lng }}
      onCloseClick={() => {
        console.log("[InfoWindow] Closed for:", centre.id);
        onClose();
      }}
      options={{ zIndex: 1000 ,
        pixelOffset: new window.google.maps.Size(0, -30) 
      }}
    >
      <div>
        <h5>{centre.sitename || centre.name}</h5>
        <ul>
          <li><strong>Site Name:</strong> {centre.sitename || "N/A"}</li>
          <li><strong>Company:</strong> {centre.company || "N/A"}</li>
          <li><strong>Category:</strong> {centre.category || "N/A"}</li>
          <li><strong>Sub-Category:</strong> {centre.subcategory || "N/A"}</li>
          <li><strong>Country:</strong> {centre.country || "N/A"}</li>
          <li><strong>Size (Live):</strong> {centre.size_l ? `${centre.size_l} MW` : "N/A"}</li>
          <li><strong>Size (Under Construction):</strong> {centre.size_u ? `${centre.size_u} MW` : "N/A"}</li>
          <li><strong>Size (Design):</strong> {centre.size_d ? `${centre.size_d} MW` : "N/A"}</li>
        </ul>
      </div>
    </InfoWindowF>
  );
};

// Only re-render if ID or coordinates change
const areEqual = (prevProps, nextProps) => {
  const prev = prevProps.centre;
  const next = nextProps.centre;
  return (
    prev?.id === next?.id &&
    prev?.latitude === next?.latitude &&
    prev?.longitude === next?.longitude
  );
};

export default React.memo(SearchInfoWindow, areEqual);
